import React, { useEffect } from 'react';
import { DatePicker, Input, Select, Form, Button, Col, InputNumber, message, Radio } from 'antd';
import { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import constants from '../../../constants';
//import 'antd/dist/antd.css';
import './PaymentForm.scss';
// import Order from '../../Model/models/orderModel';
import moment from 'moment';
import OrderPayment from '../../../Model/Payment';
import Order from '../../../Model/models/orderModel';
import PaymentType from '../../../Model/models/paymentTypeModel';
import authAxios from '../../../authorization/axios';

interface Props {
  orderId?: number,
  rowData?: any,
  importedOrder?: Order,
  payments?: OrderPayment[],
  full?: boolean,
  save?: false,
  onPaymentSave?: (payment: OrderPayment) => void,
  closeModal: () => void;
}

const PaymentForm = ({ orderId, rowData, closeModal, full, save, onPaymentSave, importedOrder, payments }: Props) => {
  const [loading, setLoading] = useState(false);
  const [paymentTypeId, setPaymentTypeId] = useState<number>();
  const [paymentTypes, setPaymentTypes] = useState<PaymentType[]>([]);
  const [percentage, setPercentage] = useState(0);
  const [totalToPay, setTotalToPay] = useState(0);
  const [firstInoviceAlreadyExist, setFirstInoviceAlreadyExist] = useState(false);
  const [remainPercentage, setRemainPercentage] = useState(100);
  const [remainTotal, setRemainTotal] = useState(0);
  const [convertRatio, setConvertRatio] = useState<number>();
  const [currency, setCurrency] = useState<string>();
  const [order, setOrder] = useState<Order>();
  const [customPercentage, setCustomPercentage] = useState<number>(0);

  const [form] = Form.useForm();

  const paymentId = rowData?.id;

  const { t } = useTranslation();

  const getPayment = () => {
    return authAxios.get(constants.api.getPayment.replace('{paymentId}', paymentId?.toString())).then((resultPayment) => {
      if (resultPayment.data && resultPayment.data.data) {
        const paymentData = resultPayment.data.data;
        return paymentData;
      }
    });
  };

  const getOrderPayments = () => {
    if (orderId === undefined) {
      return;
    }
    return authAxios.get(constants.api.getOrderPayments.replace('{orderId}', orderId.toString()))
      .then((resultOrderPayments) => {
        if (resultOrderPayments.data) {
          return resultOrderPayments.data.data;
        }
        return [];
      });
  };

  const getOrder = async () => {
    await authAxios.get(constants.api.getPaymentTypes).then((res) => {
      setPaymentTypes(res.data.data);
    });
    return authAxios.get(`${constants.api.getOrder}/${orderId}`).then((resultOrder) => {
      if (resultOrder.data) {
        return resultOrder.data.data;
      }
      return undefined;
    });
  };

  const roundToNDecimals = (amount: number, decimals: number = 6) => {
    const n = 10 ** decimals;
    return Math.round(amount * n) / n;
  };

  const convertFiatIn = async (crypto: string, date: Date) => {
    const result = await axios.get(
      `https://api.coingecko.com/api/v3/coins/${crypto}/history?date=${moment(date).format('DD-MM-YYYY')}`
    );
    return result.data.market_data?.current_price;
  };


  const configureFromImportedOrder = async (orderPayments: OrderPayment[], o: Order) => {
    await authAxios.get(constants.api.getPaymentTypes).then((res) => {
      setPaymentTypes(res.data.data);
    });
    if (orderPayments.length === 0) {
      setRemainPercentage(100);
      setRemainTotal(o.total);
      setTotalToPay((o.total || 0));
      setPercentage(100);
      setOrder(o);
      form.setFieldsValue({
        fiatAmount: Math.round((o.total || 0) * 100) / 100,
        amount: Math.round((o.total || 0) * 100) / 100,
        percentage: 100
      });
    } else {
      if (orderPayments.length > 0) {
        setFirstInoviceAlreadyExist(true);
      }
      const rp = 100 - orderPayments.filter(p => !p.isFullBilling)
        .map(d => d.percentage)
        .reduce((a, b) => a + b, 0);
      const rt = orderPayments.filter(p => !p.isFullBilling)
        .map(d => d.fiatAmount)
        .reduce((a, b) => a - b, o.total);
      setRemainPercentage(rp);
      setRemainTotal(rt);
      setTotalToPay((o.total || 0));
      setPercentage(rp);
      setOrder(o);
      form.setFieldsValue({
        fiatAmount: Math.round((o.total || 0) * rp) / 100,
        amount: Math.round((o.total || 0) * rp) / 100,
        percentage: rp
      });
    }
  };

  useEffect(() => {
    if (orderId !== undefined) {
      getOrder()
        .then(async (o: Order | undefined) => {
          if (o !== undefined) {
            setOrder(o);
            if (full) {
              setRemainPercentage(100);
              setTotalToPay((o.total || 0));
              setPercentage(100);
              form.setFieldsValue({
                fiatAmount: (o.total || 0),
                amount: (o.total || 0),
                percentage: 100
              });
            } else {
              const paymentsFromApi: OrderPayment[] = await getOrderPayments();
              if (paymentId) {
                const paymentData = await getPayment();
                const rp = 100 - paymentsFromApi.filter(p => !p.isFullBilling && paymentData.id !== p.id)
                  .map(d => d.percentage)
                  .reduce((a, b) => a + b, 0);
                setRemainPercentage(rp);
                setTotalToPay((o.total || 0));
                setFirstInoviceAlreadyExist(true);
                setPercentage(paymentData.percentage);
                form.setFieldsValue({
                  id: paymentData.id,
                  PaymentDeadline: moment(paymentData.date),
                  status: paymentData.status,
                  fiatAmount: paymentData.fiatAmount,
                  amount: paymentData.amount,
                  note: paymentData.note,
                  payment_type_id: paymentData.paymentTypeId,
                  percentage: paymentData.percentage
                });
                return;
              }
              if (paymentsFromApi.length > 0) {
                setFirstInoviceAlreadyExist(true);
              }
              const rp = 100 - paymentsFromApi.filter(p => !p.isFullBilling)
                .map(d => d.percentage)
                .reduce((a, b) => a + b, 0);
              setRemainPercentage(rp);
              setTotalToPay((o.total || 0));
              setPercentage(rp);
              form.setFieldsValue({
                fiatAmount: Math.round((o.total || 0) * rp) / 100,
                amount: Math.round((o.total || 0) * rp) / 100,
                percentage: rp
              });
            }
          }
        });
    } else {
      if (payments && importedOrder) {
        configureFromImportedOrder(payments, importedOrder).then(() => { });
      }
    }
  }, []);

  const calculateAmounts = async (ptId?: number, perc?: number) => {
    const paymentType = paymentTypes.find(p => p.id === (ptId || paymentTypeId));
    if (paymentType && order) {
      const data: { currency?: string, amount: number, fiatAmount: number, convertRatio?: number; } = {
        currency: order.currency,
        amount: order.total,
        convertRatio: undefined,
        fiatAmount: order.total
      };
      if (['PLANETS', 'USDT', 'USDC', 'ALGO'].indexOf(paymentType.currency) > -1) {
        let crypto: string | undefined = undefined;
        switch (paymentType.currency) {
          case 'PLANETS':
            crypto = 'planetwatch';
            data.currency = 'PLANETS';
            break;
          case 'USDT':
            crypto = 'tether';
            data.currency = 'USDT';
            break;
          case 'USDC':
            crypto = 'usd-coin';
            data.currency = 'USDC';
            break;
          case 'ALGO':
            crypto = 'algorand';
            data.currency = 'ALGO';
            break;
          default:
            break;
        }
        if (crypto) {
          const convertData = await convertFiatIn(crypto, new Date());
          data.convertRatio = convertData[(order?.currency || '').toLowerCase()];
          data.amount = roundToNDecimals(
            totalToPay * ((perc || percentage) / 100) / convertData[(order?.currency || '').toLowerCase()]
          );
          data.fiatAmount = Math.round(totalToPay * (perc || percentage)) / 100;
        }
      } else {
        data.convertRatio = undefined;
        const fiatAmount = Math.round(totalToPay * (perc || percentage)) / 100;
        data.amount = fiatAmount;
        data.fiatAmount = fiatAmount;
      }
      return data;
    }
  };

  const handleFinish = (values: any) => {
    const paymentData: OrderPayment = {
      id: values.id,
      paymentTypeId: values.payment_type_id,
      percentage: percentage,
      billingCode: null,
      deadlineDate: values.PaymentDeadline,
      isFullBilling: full ? true : null,
      amount: values.amount,
      fiatAmount: values.fiatAmount,
      note: values.note,
      orderId: Number(orderId),
      status: values.status
    };
    console.log(values);
    setLoading(true);

    if (save === undefined || save) {
      let promise = !rowData?.id
        ? authAxios.post(constants.api.addPayment, paymentData)
        : authAxios.put(constants.api.updatePayment, paymentData);
      promise.then((res: any) => {
        if (res.data.success) {
          setLoading(false);
          message.success({
            content: t('PAYMENT_SAVED'),
            style: {
              marginTop: 100,
              zIndex: 110000
            }
          });
          setPercentage(0);
          setTotalToPay(0);
          if (onPaymentSave) {
            onPaymentSave(res.data.data);
          }
          closeModal();
        }
      }).catch((err) => {
        setLoading(false);
        message.error({
          content: err?.response?.data?.errorMessage ? err?.response?.data?.errorMessage : err.message,
          style: {
            marginTop: 100,
            zIndex: 110000
          }
        });
      });
    } else {
      if (onPaymentSave && paymentData.percentage > 0 && paymentData.percentage <= 100) {
        onPaymentSave(paymentData);
      }
    }
  };

  const updateAmounts = async (ptId?: number, perc?: number) => {
    if (ptId !== undefined) {
      setPaymentTypeId(ptId);
    }
    const data = await calculateAmounts(ptId, perc);

    setConvertRatio(data?.convertRatio);
    setCurrency(data?.currency);

    form.setFieldsValue({
      amount: data?.amount,
      fiatAmount: data?.fiatAmount
    });
  };

  return <Container fluid className='d-flex'>
    <div style={{ width: '100%', margin: '0 auto' }}>
      <Form
        style={{ padding: 20 }}
        form={form}
        layout='vertical'
        onFinish={handleFinish}
        initialValues={{
          PaymentDeadline: moment().add(14, 'days'),
          amount: !rowData?.id ? 0 : rowData?.amount || 0,
          fiatAmount: !rowData?.id ? 0 : rowData?.fiatAmount || 0
        }}
      >
        <Row style={{ marginLeft: 2 }}>

          <Col span={12}>
            <Form.Item
              label={t('PAYMENT_METHOD')}
              name='payment_type_id'
              rules={[{ required: true, message: t('MISSING_PAYMENT_METHOD') }]}>
              <Select
                style={{ width: 200 }}
                disabled={rowData?.id !== undefined}
                onChange={(v: number) => updateAmounts(v)}
              >
                <Select.Option value=''>-</Select.Option>
                {paymentTypes && paymentTypes.map((pt: any) => <Select.Option
                  key={pt.id}
                  value={pt.id}
                >
                  {pt.type} - {pt.currency}
                </Select.Option>)}
              </Select>
            </Form.Item>
            <Form.Item
              label={t('STATUS')}
              name='status'
              style={{ display: !rowData?.id ? 'none' : 'block' }}
            >
              <Select >
                <Select.Option value='paid'>{t('PAID')}</Select.Option>
                <Select.Option value='not_paid'>{t('NOT_PAID')}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name='id'
              style={{ display: 'none' }}
            >
              <Input hidden />
            </Form.Item>
            <Form.Item
              label={t('PAYMENT_DEADLINE')}
              name='PaymentDeadline'
              rules={[{ required: true, message: t('MISSING_DATE') }]}>
              <DatePicker disabled={paymentTypeId === undefined} style={{ width: '100%', marginRight: 30 }} format={'DD-MM-YYYY'} />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginLeft: 2, marginTop: 10 }}>
          <Col span={11}>
            <Form.Item
              name='id'
              style={{ display: 'none' }}
            >
              <Input hidden />
            </Form.Item><b>
              {t('TOTAL_TO_PAY')}: € {Math.round(totalToPay * remainPercentage) / 100} ({Math.round(remainPercentage * 100) / 100}%)
            </b>
            <Form.Item
              name='percentage'
              rules={[{ required: true, message: t('MISSING_PERCENTAGE') }]}>

              <Radio.Group
                disabled={paymentTypeId === undefined}
                value={percentage}
                style={{ marginLeft: 20 }}
                onChange={(e) => {
                  setPercentage(e.target.value);
                  updateAmounts(undefined, e.target.value);
                }}
              >
                <Row>
                  <Col span={24}>
                    <Radio
                      value={30}
                      style={{ display: !rowData?.id && !firstInoviceAlreadyExist && !full ? 'block' : 'none' }}
                    >30%</Radio>
                    <Radio
                      value={70}
                      style={{ display: !rowData?.id && !firstInoviceAlreadyExist && !full ? 'block' : 'none' }}
                    >70%</Radio>
                    <Radio
                      value={100}
                      style={{ display: !rowData?.id && !firstInoviceAlreadyExist && !full ? 'block' : 'none' }}
                    >100%</Radio>
                    <Radio value={customPercentage}>
                      <InputNumber
                        disabled={paymentTypeId === undefined}
                        onChange={(e) => {
                          if (e !== null) {
                            const perc = e / (order?.total || 0);
                            setCustomPercentage(perc * 100);
                          }
                        }}
                        min={1}
                        max={remainTotal}
                      /> / {remainTotal} <br />
                      <small>Order perc. {Math.round(customPercentage * 100) / 100}%</small>
                    </Radio>
                  </Col>
                </Row>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={11} offset={1}>
            <Form.Item
              // style={{ display: 'none' }}
              label={t('FIAT_AMOUNT')}
              name='fiatAmount'
              rules={[{ required: true, message: t('MISSING_AMOUNT') }]}
            >
              <InputNumber disabled style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label={t('AMOUNT')}
              name='amount'
              rules={[{ required: true, message: t('MISSING_AMOUNT') }]}
            >
              <InputNumber disabled style={{ width: '100%' }} />
            </Form.Item>
            {
              convertRatio !== undefined &&
              <div>
                <small>
                  <b>{order?.currency}/{currency}:</b> {convertRatio}
                  <br />
                  {Math.round(totalToPay * percentage) / 100} € = {roundToNDecimals(totalToPay * (percentage / 100) / convertRatio)}
                  {currency}
                </small>
              </div>
            }
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item label={t('NOTE')} name='note'>
              <Input.TextArea showCount maxLength={500} disabled={paymentTypeId === undefined} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button
            loading={loading}
            type='primary'
            htmlType='submit'
          >
            {t('SAVE')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  </Container >;
};


export default PaymentForm;